import { render } from "./EventosResult.vue?vue&type=template&id=781bbdd2&scoped=true"
import script from "./EventosResult.vue?vue&type=script&lang=js"
export * from "./EventosResult.vue?vue&type=script&lang=js"

import "./EventosResult.vue?vue&type=style&index=0&id=781bbdd2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781bbdd2"]])

export default __exports__